import types from 'redux/actions/actionTypes';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';

import { axiosV2 } from 'interceptors/axios';
import { ApiQueryParams, SharesTitle } from 'types';
import { Dispatch } from 'redux';

type GetShareTitlesProps = {
  societyId: string;
  params?: ApiQueryParams;
  includeRanges?: boolean;
  signal?: AbortSignal;
};

export const getShareTitles =
  ({
    societyId,
    params = {},
    includeRanges = false,
    signal, // eslint-disable-line
  }: GetShareTitlesProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get(`/sharesTitles`, {
        params: {
          societyId,
          includeRanges,
          ...params,
        },
        // signal,
      });

      const decodedData = await decryptResponse(data);

      dispatch({
        type: types.GET_SHARES_TITLES,
        sharesTitles: decodedData,
      });
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const updateSharesTitle =
  (sharesTitleData: Partial<SharesTitle>) => async (dispatch: any) => {
    try {
      const body = { ...sharesTitleData };

      const { data } = await axiosV2.put(`/sharesTitles`, body);
      const decodedData = await decryptResponse(data);

      dispatch({
        type: types.UPDATE_SHARES_TITLE,
        sharesTitle: decodedData,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
